/**
 * Multi-select over the tenant's live collections. Never creates one: creating a
 * collection is a management act and lives on the Collections screen.
 */
import type { CollectionRef } from "../lib/types";

export function CollectionPicker({
  value,
  options,
  onChange,
}: {
  /** ids of the collections currently attached. */
  value: readonly string[];
  /** the tenant's live (non-archived) collections to choose among. */
  options: readonly CollectionRef[];
  onChange: (next: string[]) => void;
}) {
  if (options.length === 0) {
    return (
      <p className="font-mono text-[11px] text-faint">
        &gt; no collections yet — create one from the Collections screen
      </p>
    );
  }
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((collection) => {
        const checked = value.includes(collection.id);
        return (
          <label
            key={collection.id}
            className={`flex cursor-pointer items-center gap-1.5 border px-2 py-1 font-mono text-[10.5px] uppercase transition-colors duration-200 ease-alt ${
              checked ? "border-gold text-gold" : "border-hair text-dim hover:text-text"
            }`}
          >
            <input
              type="checkbox"
              checked={checked}
              onChange={() =>
                onChange(
                  checked
                    ? value.filter((id) => id !== collection.id)
                    : [...value, collection.id],
                )
              }
              className="sr-only"
            />
            {collection.name}
          </label>
        );
      })}
    </div>
  );
}
